export const parseUserToModel = (user) => ({
    id: user?.id,
    email: user?.email,
    status: user?.status,
    languageId: user?.languageId,
    createdOn: user?.createdOn,
    lastLogin: user?.lastLogin,
    lastPasswordReset: user?.lastPasswordReset,
});
